export default (theme) => ({
  mainLogo: {
    width: 137,
    margin: "0 auto",
  },
});
